'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const skeleton_types = require('../Skeleton/skeleton.types.js');
const image_style = require('./image.style.js');
const LazyLoad = _interopDefault(require('react-lazyload'));
const FixedAspect = require('../utilComponents/FixedAspect.js');
const handlerHelper = require('../../utils/handlerHelper.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SPACE = ' '; // Construct a srcset string if passed an object

var getSrcsetString = function getSrcsetString(srcset) {
  if (typeof srcset === 'string') {
    return srcset;
  }

  var arr = [];

  for (var s in srcset) {
    arr.push(srcset[s] + SPACE + s);
  }

  return arr.join(', ');
}; // Made the Image component a class to make use of state for
// error image handing


var Image = function Image(_ref) {
  var _ref$lazyload = _ref.lazyload,
      lazyload = _ref$lazyload === void 0 ? false : _ref$lazyload,
      srcset = _ref.srcset,
      sizes = _ref.sizes,
      src = _ref.src,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      height = _ref.height,
      alt = _ref.alt,
      title = _ref.title,
      _ref$lazyloadOffset = _ref.lazyloadOffset,
      lazyloadOffset = _ref$lazyloadOffset === void 0 ? 200 : _ref$lazyloadOffset,
      placeHolderHeight = _ref.placeHolderHeight,
      placeHolderWidth = _ref.placeHolderWidth,
      errorImageSrc = _ref.errorImageSrc,
      _ref$fixAspect = _ref.fixAspect,
      fixAspect = _ref$fixAspect === void 0 ? false : _ref$fixAspect,
      ratio = _ref.ratio,
      _ref$handlers = _ref.handlers,
      handlers = _ref$handlers === void 0 ? {} : _ref$handlers,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      border = _ref.border,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? '0px' : _ref$padding,
      borderRadius = _ref.borderRadius,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      dataAttr = _ref.dataAttr;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      srcSetDisabled = _useState4[0],
      setSrcSetDisabled = _useState4[1];

  var _useState5 = React.useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      errSrc = _useState6[0],
      setErrorImageSrc = _useState6[1]; // Handle the image error.
  // If there is a handler, call it.
  // If there is a provided error image src, use it
  // Else if we have a fallback image, use it
  // If nothing else, set to invisible


  var handleImageError = function handleImageError(e) {
    if (errorImageSrc) {
      setSrcSetDisabled(true);
      setErrorImageSrc(errorImageSrc);
    } else {
      setVisible(false);
    }
  }; // Establish the src and srcset strings


  var _theme$dark = theme.dark,
      dark = _theme$dark === void 0 ? false : _theme$dark;
  var srcString = errSrc || src;
  var srcsetString = srcset && !srcSetDisabled ? getSrcsetString(srcset) : undefined; // Set up the handlers

  var imageHandlers = {
    onError: function onError(e) {
      handleImageError();
    }
  };
  var combinedHandlers = handlerHelper(null, handlers, imageHandlers); // Set up the image itself

  var image = /*#__PURE__*/React__default.createElement(image_style.Img, _extends({
    key: src,
    src: srcString,
    srcSet: srcsetString,
    sizes: sizes,
    alt: alt,
    title: title,
    width: fixAspect ? '100%' : width,
    height: height,
    backgroundColor: backgroundColor,
    padding: padding,
    rounded: rounded,
    borderRadius: borderRadius
  }, combinedHandlers, dataAttr)); // Fix the image aspect ratio if flag is passed

  if (fixAspect) {
    image = /*#__PURE__*/React__default.createElement(FixedAspect, {
      ratio: ratio
    }, image);
  }

  if (lazyload) {
    var placeholderBgColor = dark ? skeleton_types.SkeletonColors.dark.main : skeleton_types.SkeletonColors.primary.main;
    var placeholderComp = /*#__PURE__*/React__default.createElement(image_style.Placeholder, {
      h: height,
      w: width,
      placeholderWidth: placeHolderWidth,
      placeholderHeight: placeHolderHeight,
      backgroundColor: placeholderBgColor,
      border: border,
      ratio: ratio
    });
    image = /*#__PURE__*/React__default.createElement(LazyLoad, {
      placeholder: placeholderComp,
      once: true,
      offset: [lazyloadOffset, 0]
    }, image);
  }

  return /*#__PURE__*/React__default.createElement(image_style.ImageWrapper, {
    className: className,
    rounded: rounded,
    visible: visible,
    w: width,
    h: height,
    border: border,
    borderRadius: borderRadius
  }, image);
};

module.exports = Image;
